const DENIED_REASONS = {
    PAGE_PERMISSION_NOT_GRANTED: {
        title: '你还不能访问这个页面',
        description: '你还没有这个页面的访问权限，请联系应用负责人开通权限。',
    },
    PAGE_NOT_REGISTERED: {
        title: '这个页面还没有接入权限管理',
        description: '该页面尚未纳入访问配置，请联系应用负责人重新同步页面。',
    },
    PAGE_CATALOG_UNSYNCED: {
        title: '应用还没有完成页面接入',
        description: '应用负责人尚未同步页面清单，请联系负责人开通后再试。',
    },
    PARTNER_ACCESS_NOT_CONFIGURED: {
        title: '应用还没有对其他人开放',
        description: '应用负责人还没有开放给其他人，请联系负责人开通后再试。',
    },
}

const DEFAULT_DENIED_REASON = {
    title: '你还不能访问这个页面',
    description: '当前访问未通过校验，请联系应用负责人确认后再试。',
}

export const getDeniedReasonContent = reason => DENIED_REASONS[reason] || DEFAULT_DENIED_REASON

export const shouldPromptRouteResync = reason => reason === 'PAGE_NOT_REGISTERED'

const ROUTE_SETUP_REASONS = new Set(['PAGE_NOT_REGISTERED', 'PAGE_CATALOG_UNSYNCED'])

export const getDeniedReasonAction = reason => ROUTE_SETUP_REASONS.has(reason)
    ? {
        requestLabel: '提醒负责人处理',
        submittedLabel: '已提醒负责人',
        requestHint: '发送钉钉提醒，请负责人同步页面',
        guideTitle: '等待负责人完成页面接入',
        steps: ['发送提醒，通知应用负责人同步页面清单。', '负责人开通后，等待约 30 秒再重新检查。'],
    }
    : {
        requestLabel: '申请访问权限',
        submittedLabel: '申请已发送',
        requestHint: '发送钉钉开通权限消息',
        guideTitle: '申请应用访问权限',
        steps: ['提交申请，系统会通过钉钉提醒应用负责人开通权限。', '负责人开通后，等待约 30 秒再重新检查。'],
    }

export { buildAccessRequestText } from './vibeOwnerAccessStatus'
